import React from "react";
import toast, { Toast } from "react-hot-toast";
import styled from "styled-components";
import { Icon } from "../Icon/Icon";
import CloseIcon from "@/assets/icons/CloseIcon.svg";
import CheckIcon from "@/assets/icons/Check.svg";
import theme from "@/themes/velys-theme";

const ToastContainer = styled.div`
  background: ${(props) => props.theme.white};
  color: #363636;
  padding: 15px;
  border-radius: 8px;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  max-width: calc(100vw - 40px);

  @media (max-width: 768px) {
    max-width: calc(100vw - 32px);
  }
`;

const Message = styled.span`
  line-height: 1.5;
`;

interface CustomToastProps {
  t: Toast;
  message: string;
  showCloseButton?: boolean;
  success?: boolean;
}

export default function CustomToast({
  t,
  message,
  showCloseButton = true,
  success = false,
}: CustomToastProps) {
  return (
    <ToastContainer>
      {success && (
        <Icon
          url={CheckIcon.src}
          color={theme.green}
          height="20px"
          width="20px"
          onPress={() => toast.dismiss(t.id)}
        />
      )}
      <Message>{message}</Message>
      {showCloseButton && (
        <Icon
          url={CloseIcon.src}
          color={theme.black}
          height="20px"
          width="20px"
          onPress={() => toast.dismiss(t.id)}
        />
      )}
    </ToastContainer>
  );
}
